let secondChannel = {
    'codapayId': ['codapay_1', 'codapay_220','codapay_221', 'codapay_223'],
    'codapayPh':['codapay_253','codapay_250', 'codapay_251', 'codapay_252'],
    'pepay':['pepay_webatm_idr','pepay_alfamart_idr'],
    'pepay_store': ['pepay_store_ibon_twd','pepay_store_fami_twd','pepay_store_hilifeet_twd','pepay_store_okgo_twd']
}


export default secondChannel;


// WEBPACK FOOTER //
// ./js/component/recharge/second-config.js